import { render, staticRenderFns } from "./CategoryPanel.vue?vue&type=template&id=ffa6d780&scoped=true&"
import script from "./CategoryPanel.vue?vue&type=script&lang=js&"
export * from "./CategoryPanel.vue?vue&type=script&lang=js&"
import style0 from "./CategoryPanel.vue?vue&type=style&index=0&id=ffa6d780&prod&lang=scss&scoped=true&"
import style1 from "./CategoryPanel.vue?vue&type=style&index=1&id=ffa6d780&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffa6d780",
  null
  
)

export default component.exports